<template>
  <div class="draggableContainer">
    <Draggable
      v-for="(prop, key) in props"
      :key="key"
      v-if="~computedPropsInEditMode.indexOf(key)"
      :propName="key"
      :propVal="prop"
      />
  </div>
</template>

<script>
import { mapState } from 'vuex'
// components
import Draggable from './Draggable'

export default {
  props: ['props'],
  components: {
    Draggable
  },
  computed: {
    ...mapState([
      'computedPropsInEditMode'
    ])
  }
}
</script>
